<template>
    <div class="inner-conntent">
        <div class="logo">
            <!-- <img :src="logo"> -->
        <div class="tips-box" v-if="showMaintain">
            <div class="gt-tips">
                {{$t('message.maintain')}}
            </div>
        </div>
        </div>
        <!-- <div class="nav">
            <router-link :to="{name:'login'}" class="login_a" v-if="Step !== 'set'">{{$t('message.login')}}</router-link>
            <router-link :to="{name:'register'}" class="reg_a" v-if="Step == 'reg'"> {{$t('message.register')}}</router-link>
            <router-link :to="{name:'reset'}"   class="forget" v-if="Step == 'forget'">{{$t('message.forget')}}</router-link>
            <router-link :to="{name:'set'}"   class="set" v-if="Step == 'set'">{{$t('message.reset')}}</router-link>
            <div class="active-line"></div>
            <div class="line"></div>
        </div> -->
        <router-view></router-view>
    </div>
</template>

<script>
import logo from "assets/img/geetest-logo.svg"
    export default{
        data(){
            return{
                logo:logo,
                Step: '',
                showMaintain: false
            }
        },
        methods: {},
        created() {
             let full = this.$route.fullPath;
            if(full.indexOf('reset') != -1){
                this.Step = 'forget';
            }
            else if(full.indexOf('set') != -1){
                this.Step = 'set'
            }
            else {
                this.Step = 'reg'
            }
        },
        components:{
        }
    }
</script>
<style rel="stylesheet/less" lang="less">
    .logo {
        text-align: center;
        img {
            width: 150px;
        }
    }
    .tips-box{
        position: relative;
        height: 80px;
    }
    .gt-tips{
        position: absolute;
        top: 40px;
        left: -100px;
        box-sizing: border-box;
        display: block;
        min-height: 42px;
        width: 500px;
        max-width: 500px;
        border-radius: 3px;
        background-color: #fff;
        padding: 11px 17px;
        border: 1px solid rgba(57,115,255,.6);
        color: #3973ff;
        font-size: 14px;
        line-height: 20px;
        text-align: left;

        &:after{
            content: "";
            height: 20px;
            width: 4px;
            position: absolute;
            background-color: #3973ff;
            left: 0;
            top: 10px;
            border-radius: 0 3px 3px 0;
        }
    }
    .nav {
        position: relative;
        .router-link-active {
            color: rgba(8,33,85,1);
            font-weight: 500;
        }
        a {
            display: inline-block;
            height: 100%;
            padding: 0 0 15px 0;
            margin-right: 24px;
            box-sizing: border-box;
            cursor: pointer;
            text-decoration: none;
            position: relative;
            font-size: 18px;
            transition: color .3s ease-in-out;
            color: rgba(8,33,85,.4);

        }
        a:first-child{
            margin-right: 24px;
        }
        a:hover {
            color: rgba(8,33,85,1);
            font-weight: 500;
        }
    }
    .login_a.router-link-active ~ .active-line {
        left: 8px;
        transform: translate3d(0px, 0px, 0px);
    }
    .reg_a.router-link-active ~ .active-line {
        left: 26px;
        transform: translate3d(60px, 0px, 0px);
    }
    .forget.router-link-active ~ .active-line {
        left: 26px;
        transform: translate3d(60px, 0px, 0px);
    }
    .set.router-link-active ~ .active-line {
        left: 26px;
        transform: translate3d(0px, 0px, 0px);
    }

    .active-line {
        height: 3px;
        box-sizing: border-box;
        background-color: #93A2BB;
        position: absolute;
        left: 0;
        bottom: 1px;
        z-index: 1;
        width: 20px;
        transition: transform .3s ease-in-out;
        transform-origin: 0 0;
        border-radius: 1px;
    }

    .line {
        width: 100%;
        margin: 0px auto 27px;
        position: relative;
        top: -7px;
        z-index: -1;
    }
</style>



// WEBPACK FOOTER //
// login-register.vue?0c9c9830